module.exports = __webpack_public_path__ + "static/media/icon_insurance.98847347.svg";